import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "HistoryTableFilter" }
const _hoisted_2 = { for: "NotInvoicableFilter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        id: "NotInvoicableFilter",
        type: "checkbox",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeFilterOption && _ctx.changeFilterOption(...args)))
      }),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "NotInvoicableFilterLabel" }, " Show not invoiceable enrolments ", -1 /* CACHED */))
    ])
  ]))
}